// extracted by mini-css-extract-plugin
module.exports = {"cardGroup":"global_cardGroup__2Eor6","showallButton":"global_showallButton__1atao"};